type GroupLike = { settings?: { [key: string]: unknown } | null };

export function isEditorV2Enabled(group?: GroupLike | null): boolean {
  return Boolean(group?.settings?.editor_v2_enabled);
}

export function isCaseManagementEnabled(group?: GroupLike | null): boolean {
  return Boolean(group?.settings?.case_management_enabled);
}

export function isCaseManagementActive(group?: GroupLike | null): boolean {
  return isCaseManagementEnabled(group) && isEditorV2Enabled(group);
}
